import { useCallback } from 'react';

import useControlled from '@ecp/common/src/hooks/useControlled';

const useNumberIndicator = ({ minValue, onChange, ...props }) => {
  const { value: valueProp, disabled } = props;
  const { value, setValueWhenUncontrolled } = useControlled({
    value: valueProp,
    minValue,
  });

  const handleChange = useCallback(
    (e) => {
      let newValue = e?.target?.value ?? minValue;
      if (newValue < minValue) {
        newValue = minValue;
      }
      setValueWhenUncontrolled(newValue);
      onChange?.({
        ...e,
        target: { value: newValue },
      });
    },
    [minValue, setValueWhenUncontrolled, onChange]
  );

  const handleMinus = (e) => {
    if (!disabled) {
      let newValue = value - 1;
      if (value - 1 < minValue) {
        newValue = minValue;
      }
      setValueWhenUncontrolled(newValue);
      onChange?.({
        ...e,
        target: { value: newValue },
      });
    }
  };

  const handlePlus = (e) => {
    if (!disabled) {
      setValueWhenUncontrolled(parseInt(value) + 1);
      onChange?.({
        ...e,
        target: { value: parseInt(value) + 1 },
      });
    }
  };

  return { disabled, value, handleChange, handleMinus, handlePlus, numberInputProps: props };
};

export default useNumberIndicator;
